/* ==========================================================================
   Voile Chic — USP points placement

   The CRO section renders the USP markup in a hidden holder, because the
   surrounding product blocks are injected at run time. This moves it below
   the colour swatches.

   Any previously placed copy is removed first — the theme editor re-renders
   the section on every settings change, which would otherwise leave the old
   copy behind and stack duplicates.
   ========================================================================== */

(function () {
  var PLACED_ATTR = 'data-vc-usp-placed';

  var SWATCH_SELECTORS = [
    '.product__info-container .f-swatch__list',
    '.product__info-wrapper .f-swatch__list',
    '.wt-product__info .f-swatch__list',
    '.product__info-container .color-swatcher--container',
    '.wt-product__info .color-swatcher--container',
    '.product__info-container [class*="swatch__list"]',
    '.wt-product__info [class*="swatch__list"]'
  ];

  function swatchBlock() {
    for (var i = 0; i < SWATCH_SELECTORS.length; i++) {
      var el = document.querySelector(SWATCH_SELECTORS[i]);
      if (!el) continue;

      var group =
        el.closest('.product-form__input') ||
        el.closest('[class*="variant-picker"]') ||
        el.closest('[class*="product-form__input"]') ||
        el.closest('[data-block-id]') ||
        el.parentElement;

      if (group) return group;
    }
    return null;
  }

  function clearPlaced() {
    var old = document.querySelectorAll('[' + PLACED_ATTR + ']');
    for (var i = 0; i < old.length; i++) {
      if (old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }
  }

  function place() {
    var holder = document.getElementById('vc-usp-holder');
    if (!holder) return true; /* nothing waiting to place */

    var usp = holder.firstElementChild;
    if (!usp) return true;

    var anchor = swatchBlock();
    var mode = 'after';

    if (!anchor) {
      anchor =
        document.querySelector('.vc-vol') ||
        document.querySelector('.vc-duties-notice') ||
        document.querySelector(
          '.product__info-container form[action*="/cart/add"], .wt-product__info form[action*="/cart/add"]'
        );
      mode = 'before';
    }

    if (!anchor || !anchor.parentNode) return false;

    /* Drop any copy placed by an earlier render before inserting this one. */
    clearPlaced();

    usp.setAttribute(PLACED_ATTR, '');
    if (mode === 'after') {
      anchor.parentNode.insertBefore(usp, anchor.nextSibling);
    } else {
      anchor.parentNode.insertBefore(usp, anchor);
    }

    if (holder.parentNode) holder.parentNode.removeChild(holder);
    return true;
  }

  function start() {
    if (place()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (place() || tries > 24) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* The editor re-renders the section on every settings change. */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(start, 150);
  });

  document.addEventListener('shopify:section:unload', clearPlaced);
})();
